<template>
  <el-form ref="form" :model="form" class="box-set" label-width="120px">

    <el-card  shadow="naver">
      <el-alert title="活动信息" description="填写活动信息，* 号项为必填项！" type="success" :closable="false" show-icon>
      </el-alert>
      <!-- <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
      <el-form-item label="活动banner" hide-requied-aterisk="true">

        <div @click="handleImgPicker" class="upload-box">
          <img v-if="form.banner" :src="form.banner" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
      </el-form-item> -->
      <el-form-item label="活动名称：" prop="name" :rules="rules.names">
        <el-col :span="20">
          <el-input v-model="form.name" :maxlength=80 placeholder="活动名称"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="活动时间：" :rules="rules.activity_date">
        <el-col :span="20">
          <el-date-picker
            v-model="activity_date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="生效时间"
            end-placeholder="过期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="平台类型：" :rules="rules.platform">
          <el-radio-group v-model="form.platform">
              <el-radio label="online">线上</el-radio>
              <el-radio label="pos">线下</el-radio>
          </el-radio-group>
      </el-form-item>
      <el-form-item label="指定来源：" prop="origin" :rules="rules.origin">
          <el-checkbox-group v-model="form.origin">
              <el-checkbox label="POS">线下POS</el-checkbox>
              <el-checkbox label="YKDJ">怡康到家</el-checkbox>
              <el-checkbox label="BJRBJK">宝鸡人保健康</el-checkbox>
          </el-checkbox-group>
      </el-form-item>
      <el-form-item label="医保品：" :rules="rules.is_medical">
          <el-radio-group v-model="form.is_medical">
              <el-radio label="1">是</el-radio>
              <el-radio label="2">否</el-radio>
          </el-radio-group>
      </el-form-item>
      <el-form-item label="区域公司：" v-show="form.platform === 'pos'">
        <el-col :md="7" :lg="5">
          <!-- <el-select v-model="company_id" @change="searchLog" placeholder="选择公司"
                     style="width: 100%;" size="">
              <el-option
                      v-for="(item, index) in companyList"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
              </el-option>
          </el-select> -->
          <el-select 
              v-model="corporation_ids" 
              @change="searchLog" 
              placeholder="选择公司(默认怡康连锁)"
              style="width: 100%;" 
              size=""
              multiple
              clearable
            >
              <el-option
                label="全选"
                :value="allCompanyIds"
                @click.native="selectAll"
              ></el-option>
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="模板类型：" :rules="rules.show_type" v-model="form.show_type">
        <el-radio-group v-model="form.show_type">
          <el-radio :label="0" v-show="form.platform === 'pos'">小票金额累计</el-radio>
          <el-radio :label="1" v-show="form.platform === 'pos'">单张小票达标</el-radio>
          <el-radio :label="5" v-show="form.platform === 'pos'">单张小票达标（随机概率）</el-radio>
          <el-radio :label="2" v-show="form.platform === 'pos'">会员日活动（累计）</el-radio>
          <el-radio :label="4" v-show="form.platform === 'pos'">会员日活动（不累计）</el-radio>
          <el-radio :label="3" v-show="form.platform === 'online'">线上专享</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="消费类型：" :rules="rules.cos_type">
        <el-radio-group v-model="form.cos_type">
          <el-radio :label="0">消费</el-radio>
          <el-radio :label="1">积分</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="抽奖门槛：" :rules="rules.entry">
        <el-radio-group v-model="form.entry">
          <el-radio :label="0">有</el-radio>
          <el-radio :label="1">无</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="门槛金额：" prop="cos_fee" :rules="rules.cos_fee" v-show="form.entry === 0">
        <el-col :span="5">
          <el-input v-model="form.cos_fee" :maxlength=200 placeholder="积分或者消费金额"></el-input> 
        </el-col>
      </el-form-item>
      <el-form-item label="抽奖次数：" :rules="rules.times">
        <el-col :span="10">
          <el-input type="number" v-model="form.times" :maxlength=20 placeholder="本次活动最大抽奖次数"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="指定日期：" v-show="form.show_type === 2 || form.show_type === 4">
        <el-col :span="10">
          <el-input type="text" :rows="3" v-model="form.weekends" placeholder="输入星期几1,2,3,4,5,6,7，用英文逗号隔开，默认周一至周日"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="背景图：" :rules="rules.bac_img" style="width: 30%; display: inline-block; margin: 5px">
        <div @click="handleImgPicker('bac_img', index)" class="upload-box">
          <img v-if="form.bac_img" :src="form.bac_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>    
        </div>
        <div class="frm-tips">
          注：图片|只能上传jpg/png文件，尺寸为1170*2260，单位为px，且不超过500KB
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/28/a14488b112d9d032e0f952c7d4883b77olxlXpEdZfUrA8r9Ts5rLhZkwEDmcORr" :preview-src-list="srcList" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <!-- <el-form-item label="遮罩图：" :rules="rules.cover_img" style="width: 30%; display: inline-block; margin: 20px" v-show="form.show_type===1">
        <div @click="handleImgPicker('cover_img', index)" class="upload-box">
          <img v-if="form.cover_img" :src="form.cover_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>    
        </div>
        <div class="frm-tips">
          注：图片|只能上传jpg/png文件，尺寸为1170*2260，单位为px，且不超过500KB
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/28/a14488b112d9d032e0f952c7d4883b77olxlXpEdZfUrA8r9Ts5rLhZkwEDmcORr" :preview-src-list="srcList" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item> -->
      <el-form-item label="转盘背景图：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('circle_img', index)" class="upload-box">
          <img v-if="form.circle_img" :src="form.circle_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
        </div>
        <div class="frm-tips">
          注：图片|只能上传jpg/png文件，尺寸为835*835，单位为px，且不超过500KB
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/05/31/b23af3d7d29df5b406a4aae75e12410byhOTaViFOluzOxIR2iSGurSqHAtk6BYP" :preview-src-list="srcList1" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="转盘配置：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 20px">
        <div style="border:1px dotted #409EFF;height:280px">
          <div class="frm-tips">
            <el-form-item label="宽度(%)">  
              <el-input v-model="form.zpWidth" placeholder="请输入宽度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="上边距(vw)">  
              <el-input v-model="form.zpMarginTop" placeholder="请输入上边距"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="左边距(%)">  
              <el-input v-model="form.zpMarginLeft" placeholder="请输入左边距"></el-input>  
            </el-form-item>
          </div>
        </div>
        <div class="frm-tips">
          默认值：宽度 69，上边距 70.5，左边距 16.5
        </div>
      </el-form-item>
      <el-form-item label="圆盘指针：" :rules="rules.point_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('point_img', index)" class="upload-box">
          <img v-if="form.point_img" :src="form.point_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>          
        </div>
        <div class="frm-tips">
          注：图片|只能上传jpg/png文件，尺寸为240*240，单位为px，且不超过500KB
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/22/1071a4e805be6bcbc1b87161411d1693wYvO2Y2eoMasmtONXi87wmhFD2B0eH0N" :preview-src-list="srcList2" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="指针配置：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 20px;">
        <div  style="border:1px dotted #409EFF;height:280px">
          <div class="frm-tips">
            <el-form-item label="宽度(%)">  
              <el-input v-model="form.zzWidth" placeholder="请输入宽度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="高度(vw)">  
              <el-input v-model="form.zzHeight" placeholder="请输入上边距"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="上边距(vw)">  
              <el-input v-model="form.zzMarginTop" placeholder="请输入左边距"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="左边距(%)">  
              <el-input v-model="form.zzMarginLeft" placeholder="请输入左边距"></el-input>  
            </el-form-item>
          </div>
        </div>
        <div class="frm-tips">
          备注：宽度 26，高度 25，上边距 93，左边距 38
        </div>
      </el-form-item>
      <el-form-item label="抽奖规则：" :rules="rules.rule_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('rule_img', index)" class="upload-box">
          <img v-if="form.rule_img" :src="form.rule_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
        </div>
        <div class="frm-tips">
          注：图片|只能上传jpg/png文件，外部弹出层：1080*1833，内部弹窗居中最大宽度限制：1000px
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/11/e94c2edd6fe217a826a6892fe3f1c8317lRAT3OzkyP1G2TAn8BNpszovc7wRFAY" :preview-src-list="srcList3" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="抽奖规则配置：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 20px">
        <div class="frm-tips" style="height: 280px;border:1px dotted #409EFF;">
          <el-form-item label="宽度(%)">  
            <el-input v-model="form.cjgzWidth" placeholder="请输入宽度"></el-input>  
          </el-form-item>
        </div>
        <div class="frm-tips">
          默认值：宽度 99
        </div>
      </el-form-item>
      <el-form-item label="规则+记录：" :rules="rules.all_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('all_img', index)" class="upload-box">
          <img v-if="form.all_img" :src="form.all_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
        </div>
        <div class="frm-tips">
          注：图片|只能上传jpg/png文件，尺寸为953*261，单位为px，且不超过500KB
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/22/9afaa26e4ae94b450cef39e4b3c3da2fICwked6MwwNFPJf7T6PONGHZOH18XNhy" :preview-src-list="srcList4" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="抽奖记录背景：" :rules="rules.rec_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('rec_img', index)" class="upload-box">
          <img v-if="form.rec_img" :src="form.rec_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i> 
        </div>
        <div class="frm-tips">
          注：奖品图片|只能上传jpg/png文件，外部弹出层：1080*1833，内部弹窗居中最大宽度限制：1000px
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/22/9c2acfc1f738dae297506721c1592164ikzubM8hH7HOxhW55AxgjC9XADMzvBy7" :preview-src-list="srcList5" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="中奖记录配置：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 1px;">
        <div  style="border:1px dotted #409EFF;">
          <div class="frm-tips">
            <el-form-item label="记录宽度(%)">  
              <el-input v-model="form.zjjlWidth" placeholder="请输入宽度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="记录高度(vw)">  
              <el-input v-model="form.zjjlHeight" placeholder="请输入记录高度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="列表宽度(%)">  
              <el-input v-model="form.lbWidth" placeholder="请输入列表宽度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="列表高度(vh)">  
              <el-input v-model="form.lbHeight" placeholder="请输入列表高度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="列表上边距(vw)">  
              <el-input v-model="form.lbMarginTop" placeholder="请输入列表上边距"></el-input>  
            </el-form-item>
          </div>
        </div>
        <div class="frm-tips">
          备注：中奖记录--- 宽度 90 ，高度 126，中奖列表---  宽度 77 ，高度 54 ，上边距 20
        </div>
      </el-form-item>
      <el-form-item label="地址背景图：" :rules="rules.address_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('address_img', index)" class="upload-box">
          <img v-if="form.address_img" :src="form.address_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">
          注：奖品图片|只能上传jpg/png文件，外部弹出层：1080*1833，内部弹窗居中最大宽度限制：1000px
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/22/7c2f351b16b75a98db48a5f7ae04b50cRF8ivot3RRF05Y0TGB42K4dY8oRmtJyi" :preview-src-list="srcList6" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="地址配置：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 20px">
        <div class="frm-tips" style="height: 280px;border:1px dotted #409EFF;">
          <el-form-item label="上边距(vh)">  
            <el-input v-model="form.dzMarginTop" placeholder="请输入上边距"></el-input>  
          </el-form-item>
        </div>
        <div class="frm-tips">
          默认值：上边距 20
        </div>
      </el-form-item>
      <el-form-item label="奖品弹窗图：" :rules="rules.tan_img" style="width: 30%; display: inline-block; margin: 20px">
        <div @click="handleImgPicker('tan_img', index)" class="upload-box">
          <img v-if="form.tan_img" :src="form.tan_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
        </div>
        <div class="frm-tips">
          注：奖品图片|只能上传jpg/png文件，外部弹出层：730*1000，内部弹窗居中最大宽度限制：580px
        </div>
        <div class="upload-box">
          <el-image src="https://b-img-cdn.yaoking.cn/1/2024/04/22/f221cb8a3bb5456139f934473ffe940dqhwaRP5aNhT091CvBa0UpE8tjxakxVeJ" :preview-src-list="srcList7" class="avatar"> </el-image>
        </div>
        <div class="frm-tips">
          上图为示例图，不可编辑
        </div>
      </el-form-item>
      <el-form-item label="流水号输入框配置：" :rules="rules.circle_img" style="width: 30%; display: inline-block; margin: 20px">
        <div style="border:1px dotted #409EFF;height:280px">
          <div class="frm-tips">
            <el-form-item label="宽度(%)">  
              <el-input v-model="form.lshWidth" placeholder="请输入宽度"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="上边距(vw)">  
              <el-input v-model="form.lshMarginTop" placeholder="请输入上边距"></el-input>  
            </el-form-item>
          </div>
          <div class="frm-tips">
            <el-form-item label="左边距(%)">  
              <el-input v-model="form.lshMarginLeft" placeholder="请输入左边距"></el-input>  
            </el-form-item>
          </div>
        </div>
        <div class="frm-tips">
          默认值：宽度 60，上边距 6，左边距 20
        </div>
    </el-form-item>
    <el-form-item label="首页背景色：" :rules="rules.bac_color">
      <el-col :span="10">
        <el-input v-model="form.bac_color" :maxlength=20 placeholder="格式为#abc123"></el-input>
      </el-col>
    </el-form-item>
    <!-- <el-form-item label="奖品区背景色：" :rules="rules.cover_color" v-show="form.show_type===1">
      <el-col :span="10">
        <el-input v-model="form.cover_color" :maxlength=20 placeholder="格式为#abc123"></el-input>
      </el-col>
    </el-form-item> -->
      <el-form-item label="指定货号" v-show="form.entry === 0">
        <el-col :span="20">
          <el-input type="textarea" :rows="3" v-model="form.item_bns" placeholder="输入商品货号，用英文逗号隔开！默认所有商品都可以参与"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="活动说明：" prop="activity_explain" :rules="rules.activity_explain">
        <el-col :span="20">
          <el-input v-model="form.activity_explain" :maxlength=200 placeholder="活动说明"></el-input>
        </el-col>
      </el-form-item>
      <div class="content-center" v-if="this.form.id">
        <el-button  type="primary" @click="submitActivityActionn()" >保存</el-button>
      </div>
    </el-card>
    <el-card>
    <el-row>
        <el-alert title="奖品信息" description="填写相关奖品信息（当前可配置奖品数=6）" type="success" :closable="false" show-icon>
        </el-alert>
      </el-row>
      <el-row :gutter="20">
        <el-card
          style="width: 40%; display: inline-block; margin: 20px"
          v-for="(v, index) in form.credentialArr"
          :key="index"
        >
          <div slot="header" class="clearfix" v-if="!form.id">
            <span style="color: rgb(255, 145, 0);font-weight:600">奖品{{ index + 1 }}信息:</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="removeForm(index)"
              v-if="index != 0"
              >删除</el-button
            >
          </div>
          <el-form-item label="奖品名"  :rules="rules.name">
            <el-col :span="10">
              <el-input v-model="v.name" :maxlength=200 placeholder="填写奖品名字"></el-input>
            </el-col>
        </el-form-item>
        <el-form-item label="奖品等级" :rules="rules.color">
          <el-col :span="10">
            <el-input v-model="v.color" :maxlength=200 placeholder="一等奖"></el-input>
          </el-col>
          <div class="frm-tips">
            注：奖品等级，如一等奖、二等奖.....
          </div>
        </el-form-item>
          <el-form-item label="奖品数量" :rules="rules.number">
              <el-col :span="10">
                <el-input type="number" v-model="v.number" :maxlength=200 placeholder="填写奖品数量"></el-input>
              </el-col>
          </el-form-item>
          <el-form-item label="奖品图片" :rules="rules.img">
            <div @click="handleImgPicker('img', index)" class="upload-box">
              <img v-if="v.img" :src="v.img" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
            </div>
            <div class="frm-tips">
              注：奖品图片|只能上传jpg/png文件，尺寸为800*800，且不超过500KB
            </div>
          </el-form-item>
          <!-- <el-form-item label="奖品背面图片" v-show="form.show_type===1">
            <div @click="handleImgPicker('backimg', index)" class="upload-box">
              <img v-if="v.backimg" :src="v.backimg" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
            </div>
            <div class="frm-tips">
              注：奖品背面图片|只能上传jpg/png文件，尺寸为800*800，且不超过500KB
            </div>
          </el-form-item> -->
          <!-- <el-form-item label="中奖弹窗" :rules="rules.img_t">
            <div @click="handleImgPicker('img_t', index)" class="upload-box">
              <img v-if="v.img_t" :src="v.img_t" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>           
            </div>
            <div class="frm-tips">
              注：弹窗图片|只能上传jpg/png文件，外部弹出层：730*1000，内部弹窗居中最大宽度限制：580px，且不超过500KB
            </div>
          </el-form-item> -->
          <el-form-item label="奖品概率" :rules="rules.probability">
            <el-col :span="15">
              <el-input type="number" v-model="v.probability" :maxlength=200 placeholder="概率为整数1-10000"></el-input>
              <div class="frm-tips">
                注：后台会自动计算概率，公式=单个概率/所有概率的总和
              </div>
            </el-col>
          </el-form-item>
          <el-form-item label="优惠券ID">
            <el-col :span="10">
              <el-input type="number" v-model="v.coupon_id" :maxlength=200 placeholder="优惠券ID"></el-input>
            </el-col>
            <div class="frm-tips">
              注：没有不填，默认为空
            </div>
        </el-form-item>
           <el-form-item label="奖品梯级" v-show="form.platform === 'pos'">
            <el-col :span="10">
              <el-input type="level" v-model="v.level" :maxlength=200 placeholder="金额"></el-input>
            </el-col>
            <div class="frm-tips">
              注：没有不填，默认为空
            </div>
        </el-form-item>
          <!-- <el-form-item label="奖品背景色" :rules="rules.color">
            <el-col :span="10">
              <el-input v-model="v.color" :maxlength=200 placeholder="奖品背景色"></el-input>
            </el-col>
            <div class="frm-tips">
              注：16位RGB格式，如#FFFFFF
            </div>
        </el-form-item> -->


        </el-card>
        <el-form-item v-if="!form.id">
          <el-button type="text" @click="addRule()">+增加奖品</el-button>
          <!-- <el-button type="primary" @click="saveAllPrizes()" style="margin-left: 10px">保存所有奖品</el-button> -->
        </el-form-item>
        <el-form-item v-if="form.id > 0">
          <el-button type="primary" @click="saveAllPrizes()" style="margin-left: 10px">保存所有奖品</el-button>
        </el-form-item>
      </el-row>
    </el-card>
    <div class="content-center" v-if="!form.id">
      <el-button @click.native="handleCancel">返回</el-button>
      <el-button  type="primary" @click="submitActivityAction()" >保存</el-button>
    </div>
    <imgPicker
    :dialog-visible="imgDialog"
    :sc-status="isGetImage"
    @chooseImg="pickImg"
    @closeImgDialog="closeImgDialog"
  ></imgPicker>
  </el-form>
</template>

<script>
import { updateLottryActivity,updateLottryActivityy,getLotterysActivity,updateLottryOne,getAllCompanyList} from '../../../../api/promotions'
import imgPicker from "@/components/imageselect";
export default {
  inject: ['refresh'],
  components:{
    imgPicker
  },
  data () {
    return {
      companyList:[],
      corporation_ids:[],
      srcList: [
          'https://b-img-cdn.yaoking.cn/1/2024/04/28/a14488b112d9d032e0f952c7d4883b77olxlXpEdZfUrA8r9Ts5rLhZkwEDmcORr'
      ],
      srcList1: [
        'https://b-img-cdn.yaoking.cn/1/2024/05/31/b23af3d7d29df5b406a4aae75e12410byhOTaViFOluzOxIR2iSGurSqHAtk6BYP'
      ],
      srcList2: [
        'https://b-img-cdn.yaoking.cn/1/2024/04/22/1071a4e805be6bcbc1b87161411d1693wYvO2Y2eoMasmtONXi87wmhFD2B0eH0N'
      ],
      srcList3: [
        'https://b-img-cdn.yaoking.cn/1/2024/04/11/e94c2edd6fe217a826a6892fe3f1c8317lRAT3OzkyP1G2TAn8BNpszovc7wRFAY'
      ],
      srcList4: [
        'https://b-img-cdn.yaoking.cn/1/2024/04/22/9afaa26e4ae94b450cef39e4b3c3da2fICwked6MwwNFPJf7T6PONGHZOH18XNhy'
      ],
      srcList5: [
        'https://b-img-cdn.yaoking.cn/1/2024/04/22/9c2acfc1f738dae297506721c1592164ikzubM8hH7HOxhW55AxgjC9XADMzvBy7'
      ],
      srcList6: [
        'https://b-img-cdn.yaoking.cn/1/2024/04/22/7c2f351b16b75a98db48a5f7ae04b50cRF8ivot3RRF05Y0TGB42K4dY8oRmtJyi'
      ],
      srcList7: [
        'https://b-img-cdn.yaoking.cn/1/2024/04/22/f221cb8a3bb5456139f934473ffe940dqhwaRP5aNhT091CvBa0UpE8tjxakxVeJ'
      ],
      form: {
        id: '',
        name: '',
        use_all_shops_flag: 'true',
        activity_explain:'',
        consumption_fee:'',
        start_time: '',
        end_time: '',
        distributor_id: [],
        bac_img:'',
        cover_img:'',
        circle_img:'',
        point_img:'',
        rule_img:'',
        company_ids:'',
        all_img:'',
        rec_img:'',
        address_img:'',
        tan_img:'',
        item_bns:'',
        is_medical:2,
        origin:[],
        cos_type:0,
        entry:0,
        show_type:3,
        cos_fee:'',
        weekends:'',
        times:0,
        bac_color: '',
        cover_color:'',
        platform:'online',
        zpWidth:'',
        zpMarginTop :'',
        zpMarginLeft  :'',
        zzWidth : '',
        zzHeight : '',
        zzMarginTop :'',
        zzMarginLeft :'',
        cjgzWidth :'',
        zjjlWidth :'',
        zjjlHeight :'',
        lbWidth :'',
        lbHeight :'',
        lbMarginTop :'',
        dzMarginTop :'',
        lshWidth:'',
        lshMarginTop:'',
        lshMarginLeft:'',
        credentialArr: [
          {
            name:"",
            number: "",
            probability: "",
            img: "",
            // img_t: "",
            backimg: "",
            type:2,
            coupon_id:"",
            is_enable:1,
            color:""
          }
        ],
      },
      credential_url_index: -1,
      pickerImgType: "",
      activity_date: '',
      imgDialog: false,
      isGetImage: false,
      rules: {
        name: [
          {required: true, message: '请输入奖品名称'}
        ],
        number: [
          {required: true, message: '请输入奖品数量'}
        ],
        probability: [
          {required: true, message: '请输入概率'}
        ],
        img: [
          {required: true, message: '请输入商品图片'},
          {pattern: /^[0-9]*[1-9][0-9]*$/, message: '最少1积分'}
        ],
        color: [
          {required: true, message: '请输入商品背景色'},
        ],
        bac_color: [
          {required: true, message: '请输入背景色'},
        ],
        activity_explain: [
          {required: true, message: '请输入活动说明'},
        ],
        names: [
          {required: true, message: '请输入抽奖名称'},
        ],
        platform: [
          {required: true, message: '请输入展示类型'},
        ],
        origin: [
          {required: true, message: '请选择指定来源'},
        ],
        is_medical: [
          {required: true, message: '请输入医保品是否参与'},
        ],
        show_type: [
          {required: true, message: '请输入展示类型'},
        ],
        cos_type: [
          {required: true, message: '请输入消费类型'},
        ],
        cos_fee: [
          {required: true, message: '请输入金额或者积分'},
        ],
        activity_date: [
          {required: true, message: '请输入活动时间'},
        ],
        times: [
          {required: true, message: '请输入抽奖次数'},
        ],
        circle_img: [
          {required: true, message: '请输入奖品转盘图'},
        ]
      },
    }
  },
  computed: {
    allCompanyIds() {
      return this.companyList.map(item => item.id);
    }
  },
  methods:{
    selectAll() {
      this.corporation_ids = this.allCompanyIds;
      console.log(this.corporation_ids,'444444444444');
      this.searchLog();
    },
    saveItem(item){
    console.log(item,'99999999999');
      let that = this;
      updateLottryOne(item).then(res => {
            if(res.data.data){
                this.loading = false
                this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 2 * 1000,
                    onClose () {
                        that.refresh()
                        that.$router.go(-1)
                    }
                })
            } else {
                this.$message.error(res.data.message)
                return false
            }
        })

    },
    handleImgPicker(pickerImgType, index = 0) {
      console.log(pickerImgType, index);
      this.pickerImgType = pickerImgType;
      this.credential_url_index = index;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    pickImg (data) {  
      if (this.pickerImgType == 'img') {
          this.form.credentialArr[this.credential_url_index][this.pickerImgType] =data.url;
      }else if(this.pickerImgType == 'backimg'){
          this.form.credentialArr[this.credential_url_index][this.pickerImgType] =data.url;
      }else{
          console.log(data,'22222222222222222');
          this.form[this.pickerImgType] = data.url;
          // this.form.imgArr.push({path: 11111})
      }
      console.log(this.form,'222122222222');
      this.imgDialog = false;
    },
    closeImgDialog () {
        this.imgDialog = false
        this.isGetImage = false
    },
    addRule() {
      this.form.credentialArr.push({
          name:"",
          number: "",
          probability: "",
          img: "",
          backimg: "",
          type:2,
          number:"",
          coupon_id:"",
          level:"",
          is_enable:1,
          color:""
      });
    },
    removeForm(index) {
      this.$confirm("确定要删除该资质？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm" && index !== -1) {
               this.form.credentialArr.splice(index, 1);
          }
          done();
        },
      });
    },
    getDetailAction(id){
      getLotterysActivity(id).then(res => {
            let response = res.data.data
            console.log(response,'222222222222222')
            this.form.id = response.id
            this.form.name = response.name
            this.form.begin = response.begin
            this.form.end = response.end
            this.form.activity_explain = response.descc
            this.form.credentialArr = response.items
            this.form.cos_fee = response.cos_fee
            this.form.weekends = response.weekends
            this.form.show_type= response.show_type
            this.form.cos_type = response.cos_type
            this.form.entry = response.entry
            this.form.item_bns = response.item_bns 
            this.form.is_medical = String(response.is_medical)
            // Parse origin field, which might be a string representation of an array
            if (Array.isArray(response.origin)) {
              this.form.origin = response.origin
            } else if (typeof response.origin === 'string' && response.origin.startsWith('[')) {
              try {
                this.form.origin = JSON.parse(response.origin)
              } catch (e) {
                this.form.origin = [response.origin].filter(Boolean)
              }
            } else {
              this.form.origin = [response.origin].filter(Boolean)
            }
            console.log('Origin value:', this.form.origin)
            // Extract company IDs from the company_id object and convert to numbers
            this.corporation_ids = Object.keys(response.corporation_ids).map(id => Number(id))
            this.form.bac_img = response.bac_img
            this.form.circle_img = response.circle_img
            this.form.cover_img  = response.cover_img
            this.form.point_img  = response.point_img
            this.form.rule_img   = response.rule_img
            this.form.all_img    = response.all_img
            this.form.rec_img    = response.rec_img
            this.form.address_img = response.address_img
            this.form.tan_img   = response.tan_img
            this.form.times    = response.times
            this.form.platform    = response.platform
            this.form.bac_color    = response.bac_color
            this.form.cover_color    = response.cover_color

            this.form.zpWidth     = response.zpWidth 
            this.form.zpMarginTop     = response.zpMarginTop 
            this.form.zpMarginLeft    = response.zpMarginLeft   
            this.form.zzWidth     = response.zzWidth 
            this.form.zzHeight     = response.zzHeight 
            this.form.zzMarginTop   = response.zzMarginTop  
            this.form.zzMarginLeft  = response.zzMarginLeft 

            this.form.cjgzWidth     = response.cjgzWidth 
            this.form.zjjlWidth     = response.zjjlWidth  
            this.form.zjjlHeight    = response.zjjlHeight 
            this.form.lbWidth       = response.lbWidth  
            this.form.lbHeight      = response.lbHeight 
            this.form.lbMarginTop   = response.lbMarginTop  
            this.form.dzMarginTop   = response.dzMarginTop  

            this.form.lshWidth         = response.lshWidth 
            this.form.lshMarginTop     = response.lshMarginTop 
            this.form.lshMarginLeft    = response.lshMarginLeft

            this.activity_date = [response.begin, response.end]
        })
    },
    submitActivityAction () {
      console.log(this.form,'222222333333333')
      if(this.form.credentialArr.length < 2){
        alert('请设置奖品');
        return false;
      }
      const that = this
      // 表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.activity_date.length > 0) {
              this.form.start_time =  this.dateStrToTimeStamp(this.activity_date[0])
              this.form.end_time = this.dateStrToTimeStamp(this.activity_date[1])
          }
          updateLottryActivity(this.form).then(res => {
              if(res.data.data.length > 0){
                  this.loading = false
                  this.$message({
                      message: '保存成功',
                      type: 'success',
                      duration: 2 * 1000,
                      onClose () {
                          that.refresh()
                          that.$router.go(-1)
                      }
                  })
              } else {
                  this.$message.error(res.data.message)
                  return false
              }
          })
        } else {
          // 表单验证失败，Element UI 会自动显示字段级别的错误信息
          return false;
        }
      });
    },
    submitActivityActionn () {
      console.log(this.form,'111111111111111')
      const that = this
      // 表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.activity_date.length > 0) {
                this.form.start_time =  this.dateStrToTimeStamp(this.activity_date[0])
                this.form.end_time = this.dateStrToTimeStamp(this.activity_date[1])
          }
          updateLottryActivityy(this.form).then(res => {
              if(res.data.data.length > 0){
                  this.loading = false
                  this.$message({
                      message: '保存成功',
                      type: 'success',
                      duration: 2 * 1000,
                      onClose () {
                          that.refresh()
                          that.$router.go(-1)
                      }
                  })
              } else {
                  this.$message.error(res.data.message)
                  return false
              }
          })
        } else {
          // 表单验证失败，Element UI 会自动显示字段级别的错误信息
          return false;
        }
      });
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    saveAllPrizes() {
      console.log('Saving all prizes:', this.form.credentialArr);
      if(this.form.credentialArr.length < 2){
        alert('请设置至少2个奖品');
        return false;
      }
      const that = this;
      // 表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 暂时使用现有的更新活动API，因为它包含了奖品信息
          if (this.activity_date.length > 0) {
            this.form.start_time = this.dateStrToTimeStamp(this.activity_date[0]);
            this.form.end_time = this.dateStrToTimeStamp(this.activity_date[1]);
          }
          updateLottryOne(this.form.credentialArr).then(res => {
            if(res.data.data.success_count > 6){
              this.loading = false;
              this.$message({
                message: '所有奖品保存成功',
                type: 'success',
                duration: 2 * 1000,
                onClose () {
                  that.refresh()
                  that.$router.go(-1)
                }
              });
            } else {
              this.$message.error(res.data.message);
              return false;
            }
          });
        } else {
          // 表单验证失败，Element UI 会自动显示字段级别的错误信息
          return false;
        }
      });
    },

    handleCancel: function () {
      this.$router.go(-1)
    },
    getAllCompany(){
      getAllCompanyList().then(response=>{
          this.companyList = response.data.data
          console.log('Company List:', this.companyList);
          // Call getDetailAction after companyList is populated
          if (this.$route.params.id) {
            this.getDetailAction(this.$route.params.id)
          }
      })
    },
    searchLog () {
        // 将数组转换为逗号分隔的字符串，方便后台处理
        this.form.company_ids = this.corporation_ids.join(',');
        console.log(this.form.company_ids,'3333333333333333');
    }
  },
  mounted () {
    this.getAllCompany()
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?20ef1d44